/**
 * The type of (redux) action which sets the active DeepAI theme.
 *
 * {
 *     type: SET_DEEPAI_THEME,
 *     theme: string
 * }
 */
export const SET_DEEPAI_THEME = 'SET_DEEPAI_THEME';
